import styled from "styled-components";
import { WhitePage } from "@style/whitePage";

export const TruckSchedulePageStyle = styled(WhitePage)`

`;
